
const body = document.querySelector(`body`);

const initVideo = (url, selector) => {
  selector = selector;
  let videoFrameElement = ``;
  const videoButtonElement = body.querySelector(selector);

  if (videoButtonElement) {
    const closeVideo = () => {
      videoFrameElement.style.display = `none`;
      deleteVideoElement();
      videoFrameElement.removeEventListener(`click`, closeVideo);
    };

    const openVideo = () => {
      fillFragment(url, videoButtonElement);
      videoFrameElement = body.querySelector(`.hero__video-container:not(.hero__video)`);
      videoFrameElement.style.display = `block`;
      videoFrameElement.addEventListener(`click`, closeVideo);
    };

    videoButtonElement.addEventListener(`click`, openVideo);
  }
};

const createVideoElement = (url) => {
  const similarVideoTemplateElement = body.querySelector(`template`).content;
  const video = similarVideoTemplateElement.cloneNode(true);
  const videoFileElement = video.querySelector(`.hero__video`);
  videoFileElement.src = url;
  return video;
};

const deleteVideoElement = () => {
  const videoContainerElement = body.querySelector(`.hero__video-container`);
  videoContainerElement.remove();
};

const fillFragment = (url, videoButton) => {
  const fragment = document.createDocumentFragment();
  const parentBlockElement = videoButton.parentElement;
  fragment.appendChild(createVideoElement(url));
  parentBlockElement.appendChild(fragment);
};

window.initVideo = initVideo;